// Basic RGPD service using localStorage
const CONSENT_KEY = 'rgpd_consent';
const BANNER_KEY = 'rgpd_banner_shown';
const RIGHTS_KEY = 'artist_image_rights';
const LOG_KEY = 'rgpd_logs';

const RGPDService = {
  getConsent() {
    try {
      return JSON.parse(localStorage.getItem(CONSENT_KEY)) || null;
    } catch {
      return null;
    }
  },

  saveConsent(consent) {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  },

  hasConsent(type) {
    const c = RGPDService.getConsent();
    return !!(c && c[type]);
  },

  revokeConsent() {
    localStorage.removeItem(CONSENT_KEY);
  },

  shouldShowBanner() {
    return !localStorage.getItem(BANNER_KEY);
  },

  markBannerShown() {
    localStorage.setItem(BANNER_KEY, '1');
  },

  resetBanner() {
    localStorage.removeItem(BANNER_KEY);
    window.dispatchEvent(new CustomEvent('rgpd:show-banner'));
  },

  async getApproximateLocation() {
    return { country: 'Unknown', isEU: false };
  },

  exportUserData() {
    return RGPDService.getConsent();
  },

  deleteAllUserData() {
    localStorage.removeItem(CONSENT_KEY);
    localStorage.removeItem(RIGHTS_KEY);
  },

  saveArtistImageRights(artistId, rights) {
    const data = JSON.parse(localStorage.getItem(RIGHTS_KEY) || '{}');
    data[artistId] = rights;
    localStorage.setItem(RIGHTS_KEY, JSON.stringify(data));
  },

  getImageRights(artistId) {
    const data = JSON.parse(localStorage.getItem(RIGHTS_KEY) || '{}');
    return data[artistId];
  },

  hasImageRightsAuthorization(artistId, usage) {
    const rights = RGPDService.getImageRights(artistId);
    return !!(rights && rights.authorizedUsages && rights.authorizedUsages.includes(usage));
  },

  revokeArtistImageRights(artistId) {
    const data = JSON.parse(localStorage.getItem(RIGHTS_KEY) || '{}');
    delete data[artistId];
    localStorage.setItem(RIGHTS_KEY, JSON.stringify(data));
  },

  logRGPDAction(action, data = {}) {
    const logs = JSON.parse(localStorage.getItem(LOG_KEY) || '[]');
    logs.push({ action, data, timestamp: new Date().toISOString() });
    localStorage.setItem(LOG_KEY, JSON.stringify(logs));
  },
};

export default RGPDService;
